import { useLocation } from 'react-router'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import config from 'constants/config'
import { useMemo } from 'react'

function useIsHomepage(): boolean {
  const location = useLocation()
  return useMemo(() => {
    return !!matchLocaleAwarePath(location.pathname, { path: `/:regionCode/${config.defaultHomePage}`, exact: true })
  }, [location.pathname])
}

export default useIsHomepage
